// import React from 'react';
// import logo from './logo.svg';
// import './App.css';
// import SignIn from './pages/SignIn/SignIn';
// import MainPage from './pages/MainPage/MainPage';
// import JobsList from './components/JobsTable/JobsTable';
// import Sidebar from './components/Sidebar/Sidebar';

// function App() {
//   return (<>
//       {/* Sidebar */}
// <div style={{}}>
//       <Sidebar/>
// </div>
//         {/* <SignIn/> */}
//         <MainPage/>

// </>
//   );
// }

// export default App;

import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import SignIn from './pages/SignIn/SignIn';
import MainPage from './pages/MainPage/MainPage';
import Sidebar from './components/Sidebar/Sidebar';
import PermissionsPage from './pages/PermissionsPage/PermissionsPage';
import BusinessPage from './pages/BusinessPage/BusinessPage';
import { AddBusiness } from '@mui/icons-material';
import ReportsTable from './components/ReportsTable/ReportsTable';
import ReportsPage from './pages/ReportsPage/ReportsPage';
import { signIn }  from './Services/UserService';
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

const Layout: React.FC = () => {
  const location = useLocation();
  const hideSidebar = location.pathname === '/signin';
  const navigate = useNavigate();  
  const dispatch = useDispatch();
const user = useSelector((state: any) => state.User.loggedUser);
// ==========================================
  // פונקציית useEffect הראשונה (החלק של הרפרש)
  // ==========================================
  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      const userData = JSON.parse(savedUser);
      dispatch({ type: "SET_LOGGED_USER", payload: userData });
    }
  }, [dispatch]);

  // ==========================================
  // פונקציית useEffect השנייה (השוטר של הניווטים)
  // ==========================================
  useEffect(() => {
    const hasToken = localStorage.getItem("user");

    // אם אין משתמש ברדאקס וגם אין כלום בדפדפן -> המשתמש מנותק, עבר ל-SignIn
    if (!user && !hasToken) {
      navigate("/signin", { replace: true });
    } 
    // אם הוא מחובר ומנסה להיכנס ידנית ל-signin -> תחזיר אותו לדף הבית
    else if (user && location.pathname === '/signin' && !location.state?.loggedOut) {
      navigate("/", { replace: true });
    }
  }, [user, location.pathname, navigate]);
  return (
  <>
      {!hideSidebar && <Sidebar />} {/* Sidebar קבוע בצד ימין */}
      <div style={{ paddingRight: hideSidebar ? 0 : '6%' }}>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/signin" element={ <SignIn onSubmit={async (username, password) => {
              try {
                await signIn(username, password);
                navigate("/", { replace: true });  
              } catch (error) {
                alert("אימייל או סיסמה שגויים"); 
              }
          }} />} />
          <Route path="/permission" element={<PermissionsPage />} />
          <Route path="/business" element={<BusinessPage />} />
          <Route path="/add-business" element={<AddBusiness />} />
          <Route path="/reports" element={<ReportsPage />} />
        </Routes>
      </div>
    </>
  );
};

function App() {
  return (
      <Layout />
  );
}

export default App;

